module.exports = __webpack_public_path__ + "static/icon-big-surprise.30617562.svg";